import Vue from 'vue'
import VueRouter from 'vue-router'
import QrView from '../views/QR.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/:id',
    name: 'QR',
    component: QrView
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
